<template>
  <v-dialog v-model="dialog" max-width="600" @click:outside="cancel">
    <v-card flat v-if="user">
      <loading-spinner v-if="loading"></loading-spinner>
      <template class="py-0" v-else>
        <v-card-text class="pb-0">
          <v-row dense>
            <v-col>
              <v-card-title>
                <template v-if="canSave">
                  Manage who can review {{ user.firstName }}
                </template>
                <template v-else>
                  Who can review {{ user.firstName }}
                </template>
              </v-card-title>
              <v-card-subtitle>
                Search for new reviewers or remove existing
              </v-card-subtitle>
            </v-col>
            <v-col cols="auto" class="my-auto mr-4">
              <v-btn @click="save" :loading="saving" v-if="canSave">
                Done
              </v-btn>
              <v-btn @click="dialog = false" v-else>
                Close
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="subtitle-1 pt-0">
          <v-row dense v-if="canSave">
            <v-col :cols="12">
              <member-autocomplete
                v-model="newUsers"
                :multiple="false"
                v-on:change="addUser"
                clearOnSelection
                allowAll
                hide-details
                :memberIdsToNotShow="reviewerIds"
              ></member-autocomplete>
            </v-col>
          </v-row>
          <div class="scroll-div mr-n4 mt-4">
            <template v-for="reviewer in sorted_reviewers">
              <v-row dense :key="reviewer.id">
                <v-col cols="auto" class="my-auto">
                  <user-avatar :size="35" :user="reviewer"></user-avatar>
                </v-col>
                <v-col class="my-auto">
                  <div>{{ reviewer.fullName }}</div>
                  <div class="caption">
                    {{ reviewer.jobTitle }}
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="my-auto" v-if="canSave">
                  <v-switch
                    v-if="user.directManagerId != reviewer.id"
                    v-model="reviewer.isActive"
                    color="success"
                  ></v-switch>
                  <v-icon v-else class="px-4">lock</v-icon>
                </v-col>
              </v-row>
              <v-divider :key="reviewer.id + 'divider'"></v-divider>
            </template>
          </div>
        </v-card-text>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import MemberAutocomplete from "@/components/members/MemberAutocomplete";
export default {
  name: "EditUserReviewerDialog",
  components: { MemberAutocomplete },
  props: {},
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    saving: false,
    newUsers: [],
    user: null
  }),
  watch: {},
  computed: {
    sorted_reviewers() {
      let self = this;
      return this._.sortBy(this.reviewers, function(o) {
        return o.id != self.user.directManagerId;
      });
    },
    reviewerIds() {
      return this.reviewers.map(x => x.id);
    },
    canSave() {
      return this.user.directManagerId == this.profile.id || this.is_admin;
    },
    ...mapGetters({
      search_users: "user/search_users",
      profile: "profile/profile",
      reviewers: "user/reviewers",
      is_admin: "profile/is_admin"
    })
  },
  methods: {
    addUser(val) {
      if (val && val.length) {
        let user = this.search_users.find(x => x.id == val[0]);
        if (user) {
          let index = this.reviewers.findIndex(x => x.id == user.id);
          if (index >= 0) {
            this.reviewers[index].isActive = true;
          } else {
            this.reviewers.push(Object.assign({ isActive: true }, user));
          }
        }
      }
    },
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    save() {
      let reviewersToSave = this.reviewers.filter(x => x.isActive);
      this.saving = true;
      this.$store
        .dispatch("user/saveReviewers", {
          userId: this.user.id,
          reviewers: reviewersToSave
        })
        .then(() => {
          this.$emit(
            "save",
            this.reviewers.filter(x => x.isActive)
          );
          this.$root.$snackbarSuccess("User Reviewers saved");
          this.dialog = false;
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert("Error Occurred", "An error occurred while saving");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    showDialog(user, load) {
      this.dialog = true;
      this.user = user;
      if (load) {
        this.loading = true;
        this.$store
          .dispatch("user/getReviewers", this.user.id)
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while loading reviewers."
            );
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-div {
  overflow-y: scroll;
  max-height: 350px;
  overflow-x: hidden;
}
</style>
